import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { plans } from '../data/offer';
import { Countdown } from './Countdown';
const guarantees = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 15 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago | Tarjeta'
}];
export function FinalCtaSection() {
  return <section id="cierre" aria-labelledby="cierre-title" className="border-b border-line bg-surface/40" data-id="element-84" data-mp="2y2ranedhcl4j">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 lg:py-24" data-id="element-85" data-mp="331uit7orb7gq">
        <div className="flex flex-col items-center gap-6 text-center" data-id="element-86" data-mp="381gv9ewrgjoh">
          <h2 id="cierre-title" className="text-2xl font-black leading-tight tracking-tight text-ivory sm:text-3xl" data-id="element-87" data-mp="3cu04y0sbuuo0">
            El precio cierra en:
          </h2>
          <Countdown size="lg" data-id="element-88" data-mp="2kdh5oib6qzbh" />
        </div>

        <ul className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-89" data-mp="2kc61ihdtvpju">
          {plans.map(plan => <li key={plan.id} className={`flex h-full flex-col rounded-2xl p-6 text-center sm:p-7 ${plan.featured ? 'border-2 border-accent bg-surfaceAlt' : 'border border-line bg-surface'}`} data-id="element-90" data-mp="2dcjnfqj3j15z">
              <h3 className="text-lg font-black tracking-tight text-ivory sm:text-xl" data-id="element-91" data-mp="23low47qztbdo">
                {plan.name}
              </h3>
              <p className="mt-2 text-[15px] text-muted" data-id="element-92" data-mp="1ymc8hksas0a1">{plan.contents}</p>
              <div className="mt-6 flex flex-wrap items-end justify-center gap-3" data-id="element-93" data-mp="1ulse2oz3zarl">
                <span className="text-4xl font-black tracking-tight text-ivory" data-id="element-94" data-mp="1plwagqubplck">{plan.price}</span>
                <span className="pb-1 text-sm font-semibold text-muted" data-id="element-95" data-mp="1kmt3v1yp372h">ARS</span>
                <span className="pb-1 text-base text-muted line-through" data-id="element-96" data-mp="1fo9hj0g6vt9l">{plan.listPrice}</span>
              </div>
              <div className="mt-auto pt-7" data-id="element-97" data-mp="3f13wllieuldj">
                <a href={plan.checkoutUrl} className={`cta-breathe block w-full rounded-xl px-6 py-4 text-center text-sm font-extrabold uppercase tracking-tight transition-[background-color,border-color,color] duration-150 ease-soft ${plan.featured ? 'bg-accent text-accentInk hover:bg-[#ffbd53]' : 'border border-line bg-surfaceAlt text-ivory hover:border-accent hover:text-accent'}`} data-id="element-98" data-mp="3f0u3vq5ze045">
                  {plan.cta}
                </a>
              </div>
            </li>)}
        </ul>

        <ul className="mx-auto mt-8 grid max-w-md grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-99" data-mp="13es7lezzje9d">
          {guarantees.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-2 text-[11px] text-muted sm:text-xs" data-id="element-100" data-mp="1w2nyu46scdyr">
              <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-success" data-id="element-101" data-mp="1i36i8c3n870h" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}